import { COLORS } from '@constants';
import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledLink = styled.a`
    color: ${COLORS.$info};
    font-weight: inherit;
`;

export const StyledError = styled.div`
    border-radius: 8px;
    border: 1px solid ${COLORS.$tartRed};
    background-color: ${COLORS.$tartRedLite};
    padding: 24px;
`;

export const StyledConfirm = styled(Flex)`
    border-radius: 8px;
    border: 1px solid ${COLORS.$robinBlue};
    background-color: ${COLORS.$robinTintsBlue};
    padding: 24px;
`;

export const StyledCollapseContent = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 24px 24px 24px;
    gap: 24px;
    width: 100%;
    background: ${COLORS.$white};
    border: 1px solid ${COLORS.$gray15Black};
    border-top: none;
    border-radius: 0 0 8px 8px;
    flex: none;
    flex-grow: 0;
    margin-top: -1px;
`;
